<template>
  <div>
    <div class="mb-3">
      <p class="departure-title">{{ addressTitle.FROM ? addressTitle.FROM : 'From' }}</p>
      <gmap-autocomplete
        class="form-control mb-3"
        :value="origin.display_address"
        :disabled="origin.disabled"
        placeholder="Enter a location"
        @place_changed="setOriginPlace"
      ></gmap-autocomplete>
      <p class="distance" :class="{ invisible: distance < 0 }">
        {{ addressTitle.DISTANCE ? addressTitle.DISTANCE : 'Distance' }} {{ formatDistance(distance) }} Km
      </p>
    </div>
    <div>
      <p class="departure-title">{{ addressTitle.TO ? addressTitle.TO : 'To' }}</p>
      <div class="d-flex align-items-center justify-content-center">
        <div class="w-100">
          <gmap-autocomplete
            class="form-control"
            :value="destination.display_address"
            :disabled="destination.disabled"
            placeholder="Enter a location"
            @place_changed="setDestinationPlace"
            @blur="showAddressAgain"
          ></gmap-autocomplete>
        </div>
      </div>
      <br />
    </div>
    <hr />
    <b
      style="font-size: 12px; font-weight: 400; color: #979797"
      class="d-flex justify-content-center align-item-center cursor show-on-map"
      @click="showMap()"
    >
      {{
        !isShowMap
          ? addressTitle && addressTitle.SHOW_MAP
            ? addressTitle.SHOW_MAP
            : 'Show map'
          : addressTitle && addressTitle.HIDE_MAP
          ? addressTitle.HIDE_MAP
          : 'Hide map'
      }}
    </b>
    <div v-show="isShowMap" class="gmap">
      <Gmap-Map ref="map" style="width: 100%; height: 50vh" :zoom="7" :center="center"> </Gmap-Map>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AddressInfo',
  props: {
    addressTitle: {
      type: Object,
      default: () => {}
    },
    origin: {
      type: Object,
      default: () => {}
    },
    destination: {
      type: Object,
      default: () => {}
    },
    initShowMap: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      direct_from: {},
      direct_to: {},
      center: {},
      place: null,
      distance: 0,
      directionsService: null,
      directionsDisplay: null,
      currentDestination: {},
      isShowMap: false,
      selectedAddress: {}
    }
  },
  computed: {
    direct() {
      return { direct_from: this.direct_from, direct_to: this.direct_to }
    }
  },

  watch: {
    origin(data) {
      this.direct_from = {
        lat: data.lat,
        lng: data.lng
      }
    },
    destination(data) {
      this.direct_to = {
        lat: data.lat,
        lng: data.lng
      }
    },
    direct() {
      this.setCenter()
      this.getDirection()
    }
  },
  mounted() {
    this.initMap()
  },
  methods: {
    initMap() {
      this.direct_from = {
        lat: this.origin.lat,
        lng: this.origin.lng
      }
      this.direct_to = {
        lat: this.destination.lat,
        lng: this.destination.lng
      }

      this.setCenter()
      this.$refs.map.$mapPromise.then(() => {
        this.directionsService = new google.maps.DirectionsService()
        this.getDirection()
      })
      this.isShowMap = this.initShowMap
    },
    showAddressAgain() {
      // when user remove address and click mouse outside the address, we will return the last address again
      if (!_.isEmpty(this.selectedAddress.destination)) {
        this.$emit('updateLocation', this.selectedAddress)
      }
    },
    formatDistance(number) {
      return parseFloat(number).toFixed(1)
    },
    setCenter() {
      if (this.direct_from.lat && this.direct_from.lng) {
        this.center = {
          lat: parseFloat(this.direct_from.lat),
          lng: parseFloat(this.direct_from.lng)
        }
      } else if (this.direct_to.lat && this.direct_to.lng) {
        this.center = {
          lat: parseFloat(this.direct_to.lat),
          lng: parseFloat(this.direct_to.lng)
        }
      }
    },
    setOriginPlace(place) {
      let location = {
        lat: parseFloat(place.geometry.location.lat()),
        lng: parseFloat(place.geometry.location.lng()),
        address: place.formatted_address
      }
      let dataUpdate = {
        origin: location
      }
      this.$emit('updateLocation', dataUpdate)
    },

    setDestinationPlace(place) {
      let location = {
        lat: parseFloat(place.geometry.location.lat()),
        lng: parseFloat(place.geometry.location.lng()),
        address: place.formatted_address
      }
      let dataUpdate = {
        destination: location
      }
      this.selectedAddress = dataUpdate
      this.$emit('updateLocation', dataUpdate)
    },
    //google maps API's direction service
    calculateAndDisplayRoute(directionsService, directionsDisplay, start, destination) {
      return new Promise((resolve, reject) => {
        directionsService.route(
          {
            origin: start,
            destination: destination,
            travelMode: google.maps.TravelMode.DRIVING
          },
          (response, status) => {
            if (status === 'OK') {
              directionsDisplay.setDirections(response)
              const route = response.routes[0]
              resolve(route)
            } else {
              this.resetDestination()
              window.alert('Directions request failed due to 1' + status)
            }
          }
        )
      })
    },
    getDirection: async function () {
      let self = this
      if (!self.direct_from.lat || !self.direct_from.lng || !self.direct_to.lat || !self.direct_to.lng) {
        this.distance = 0
        return
      }
      if (this.directionsDisplay != null) {
        this.directionsDisplay.setMap(null)
        this.directionsDisplay = null
      }
      this.directionsDisplay = new google.maps.DirectionsRenderer()
      this.directionsDisplay.setMap(this.$refs.map.$mapObject)

      let from = {
        lat: parseFloat(this.direct_from.lat),
        lng: parseFloat(this.direct_from.lng)
      }
      let to = {
        lat: parseFloat(this.direct_to.lat),
        lng: parseFloat(this.direct_to.lng)
      }
      let route = null
      if (!_.isEmpty(from) && !_.isEmpty(to) && !_.isNull(this.directionsService)) {
        route = await this.calculateAndDisplayRoute(this.directionsService, this.directionsDisplay, from, to)
        this.distance = route.legs[0].distance.value / 1000
      } else {
        this.distance = 0
      }
      this.$emit('getPriceByDistance', this.distance)
      return route
    },

    showMap() {
      this.isShowMap = !this.isShowMap
      if (this.isShowMap) {
        this.getDirection()
      }
    },
    resetDestination() {
      this.$emit('clearDestinationAddress')
      this.distance = 0
      this.selectedAddress = {}
    }
  }
}
</script>
<style lang="scss" scoped>
hr {
  margin-bottom: 0;
  margin-top: 0;
}
.show-on-map {
  border: none;
}
.gmap {
  padding-top: 1.5rem;
}
.departure-title {
  font-size: 18px;
  margin-bottom: 0.5rem;
  color: #646464;
}
.pac-target-input {
  font-size: 18px;
  color: #646464;
}
.distance {
  color: #646464;
}
</style>
